<template>
  <div class="response_table">
    <div class="header_devices">
      <h4 v-if="devices.length > 0" class="title">
        {{ translate("simcard_devices.device_history") }}
      </h4>
      <h4 v-else class="title">
        {{ translate("simcard_devices.device_history_empty") }}
      </h4>
      <span v-else @click="device_show()" class="pointer switch">{{
        translate("simcard_devices.not_" + devs_show)
      }}</span>
    </div>
    <table v-if="devices.length > 0">
      <thead style="flex: 0">
        <tr>
          <th scope="col">
            {{ translate("device.history.slot") }}
          </th>
          <th scope="col">
            {{ translate("device.history.name") }}
          </th>
          <th scope="col">
            {{ translate("device.history.imsi") }}
          </th>
          <th scope="col">
            {{ translate("device.history.time") }}
          </th>
        </tr>
      </thead>
      <tbody>
        <router-link
          v-for="(dev, key) in device_list"
          :key="key"
          :to="get_name_link(dev.device_fid)"
          class="link"
        >
          <tr class="device">
            <td :data-label="translate('device.history.slot')">
              {{ dev.slot }}
            </td>
            <td
                :data-label="translate('device.history.name')"
                @click.stop=""
            >
              <router-link :to="{path: '/device/' + dev.device_fid}">
                {{ dev.device_fid }}
              </router-link>
              <p>
                {{ dev.device_name }}
              </p>
            </td>
            <td :data-label="translate('device.history.imsi')">
              {{ dev.imsi }}
            </td>
            <td :data-label="translate('device.history.time')">
              {{ get_date(dev.timestamp) }}
            </td>
          </tr>
        </router-link>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "SimcardDeviceHistory",
  props: {
    profile: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      devices: {},
      error: false,
      devs_show: "last_5_dev",
    };
  },
  computed: {
    sim_id() {
      return this.$route.params.simcard_devices_id;
    },
    device_list() {
      if (this.devs_show === "all_dev") {
        return this.devices;
      } else {
        let list = [];
        for (let key in this.devices) {
          if (key < 5) {
            list.push(this.devices[key]);
          }
        }
        return list;
      }
    },
  },

  methods: {
    device_show() {
      if (this.devs_show === "all_dev") {
        this.devs_show = "last_5_dev";
      } else {
        this.devs_show = "all_dev";
      }
    },
    get_name_link(fid) {
      if (this.$store.getters.getPermissions.permissionGod) {
        return { path: "/device/" + fid };
      }
    },
    get_device_history() {
      if (this.$route.name === "simcard_profile_section") {
        this.$http.v1.getSimcardDeviceHistory(this.profile.imsi, (response) => {
          if (
            typeof response.data.status != "undefined" &&
            response.data.status !== null
          ) {
            this.error = true;
          } else {
            this.devices = response.data;
          }
        });
      }
    },
  },
  watch: {
    sim_id() {
      this.get_device_history();
    },
  },
  created() {
    this.get_device_history();
  },
};
</script>
<style lang="scss" scoped>
.response_table {
  padding: 0;
  td{
    vertical-align: middle;
    a,p{
      font-size: 10px;
      margin-bottom: 0;
    }
  }
}
.header_devices {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  h4.title {
    font-size: 12px;
    line-height: 120%;
    font-weight: bold;
  }
  .switch {
    font-size: 12px;
    line-height: 120%;
  }
}
.link {
  cursor: pointer;
  color: #252422;
  .device {
    transition: 0.2s;
    &:hover {
      color: black;
      background-color: #eee;
    }
  }
}
</style>
